"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AuditHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-light-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1496898/img/audit_hero_neon_glitch_overlay.png)] opacity-30 animate-pulse" style={{
      animationDuration: "3s"
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-background/60 via-dark-background/40 to-transparent pointer-events-none" />

      {}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-24 text-center">
        {}
        <h1 ref={headlineRef} className={`font-display text-5xl md:text-7xl font-bold text-foreground-light mb-6 transition-all duration-700 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Discover Your Administrative Leak
        </h1>

        {}
        <p ref={subheadlineRef} className={`font-sans text-xl md:text-2xl text-foreground-light/80 mb-10 transition-all duration-700 ease-out delay-150 ${subheadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Uncover hidden inefficiencies draining your time and energy. Our
          Strategy Audit reveals exactly where to automate, streamline, and
          reclaim your rhythm.
        </p>

        {}
        <div ref={ctaRef} className={`transition-all duration-700 ease-out delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="https://forms.fillout.com/t/teUkS15Xkjus">
            <Button size="lg" className="bg-primary text-foreground-primary font-semibold text-lg px-8 py-4 rounded-md shadow-[0_0_20px_rgba(77,171,247,0.5)] hover:shadow-[0_0_30px_rgba(77,171,247,0.8)] hover:scale-[1.04] focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 transition-all duration-200 ease-out">
              Book Your Strategy Audit
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}